import BaseTrigger from "../triggers/baseTrigger.js";
import { METRICS_HINT_STEPS } from "./metrics-hints.js";

export const metricsOnboardings = [
  {
    trigger: new BaseTrigger("vueEvent", {
      event: "onboarding:clicked:metricsAiDetectionHint",
    }),
    scenario: {
      showProgress: false,
      steps: [METRICS_HINT_STEPS.aiDetection],
    },
  },
  {
    trigger: new BaseTrigger("vueEvent", {
      event: "onboarding:clicked:metricsPlagiarismHint",
    }),
    scenario: {
      showProgress: false,
      steps: [METRICS_HINT_STEPS.plagiarism],
    },
  },
  {
    trigger: new BaseTrigger("vueEvent", {
      event: "onboarding:clicked:metricsClassPerformanceHint",
    }),
    scenario: {
      showProgress: false,
      steps: [METRICS_HINT_STEPS.classPerformance],
    },
  },
  {
    trigger: new BaseTrigger("vueEvent", {
      event: "onboarding:clicked:metricsStudentGrowthHint",
    }),
    scenario: {
      showProgress: false,
      steps: [METRICS_HINT_STEPS.studentGrowth],
    },
  },
  {
    trigger: new BaseTrigger("vueEvent", {
      event: "onboarding:clicked:metricsWritingSkillsHint",
    }),
    scenario: {
      showProgress: false,
      steps: [METRICS_HINT_STEPS.writingSkills],
    },
  },
  {
    trigger: new BaseTrigger("vueEvent", {
      event: "onboarding:clicked:metricsAverageScoreHint",
    }),
    scenario: {
      showProgress: false,
      steps: [METRICS_HINT_STEPS.averageScore],
    },
  },
];
